import { createAction } from 'redux-actions';

import {
  RESET_PROJECT_IDENTIFICATION_LIST,
  LOAD_PROJECT_IDENTIFICATION_LIST,
  LOAD_PROJECT_IDENTIFICATION_LIST_SUCCESS,
  LOAD_PROJECT_IDENTIFICATION_LIST_ERROR,
  LOAD_PROJECT_IDENTIFICATION_DETAIL,
  LOAD_PROJECT_IDENTIFICATION_DETAIL_SUCCESS,
  LOAD_PROJECT_IDENTIFICATION_DETAIL_ERROR,
  CREATE_PROJECT_IDENTIFICATION,
  CREATE_PROJECT_IDENTIFICATION_SUCCESS,
  CREATE_PROJECT_IDENTIFICATION_ERROR,
  UPDATE_PROJECT_IDENTIFICATION,
  UPDATE_PROJECT_IDENTIFICATION_SUCCESS,
  UPDATE_PROJECT_IDENTIFICATION_ERROR,
} from './type';

export const resetProjectIdentificationList = createAction(
  RESET_PROJECT_IDENTIFICATION_LIST,
);

//Load list Project Identification
export const loadProjectIdentificationListAction = createAction(
  LOAD_PROJECT_IDENTIFICATION_LIST,
);
export const loadProjectIdentificationListSuccessAction = createAction(
  LOAD_PROJECT_IDENTIFICATION_LIST_SUCCESS,
);
export const loadProjectIdentificationListErrorAction = createAction(
  LOAD_PROJECT_IDENTIFICATION_LIST_ERROR,
);

//Load Project Identification detail
export const loadProjectIdentificationDetailAction = createAction(
  LOAD_PROJECT_IDENTIFICATION_DETAIL,
);
export const loadProjectIdentificationDetailSuccessAction = createAction(
  LOAD_PROJECT_IDENTIFICATION_DETAIL_SUCCESS,
);
export const loadProjectIdentificationDetailErrorAction = createAction(
  LOAD_PROJECT_IDENTIFICATION_DETAIL_ERROR,
);

//Create Project Identification
export const createProjectIdentificationAction = createAction(
  CREATE_PROJECT_IDENTIFICATION,
);
export const createProjectIdentificationSuccessAction = createAction(
  CREATE_PROJECT_IDENTIFICATION_SUCCESS,
);
export const createProjectIdentificationErrorAction = createAction(
  CREATE_PROJECT_IDENTIFICATION_ERROR,
);

//Update Project Identification
export const updateProjectIdentificationAction = createAction(
  UPDATE_PROJECT_IDENTIFICATION,
);
export const updateProjectIdentificationSuccessAction = createAction(
  UPDATE_PROJECT_IDENTIFICATION_SUCCESS,
);
export const updateProjectIdentificationErrorAction = createAction(
  UPDATE_PROJECT_IDENTIFICATION_ERROR,
);
